/**
 * Created by Pradeep Kumar on 5/24/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {TombOfNefertitiBackground} from "../../background/TombOfNefertitiBackground";
import {TombOfNefertitiGameMode} from "../../gamemode/TombOfNefertitiGameMode";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";

export class TombOfNefertitiFreeSpinIntroController extends FreespinIntroController {

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        let isTriggered:boolean = super.calculateIsTriggered(data) && data.freespinTriggeredThisSpin && data.nextMode === GameMode.FREESPIN;

        if(isTriggered) {
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiBackground.HOLD_BG_TRANSITION));
        }
        return super.calculateIsTriggered(data) && (data.nextMode === GameMode.FREESPIN || data.nextMode === TombOfNefertitiGameMode.RESPIN_FREESPIN);
    }

    protected onCloseComplete():void {
        super.onCloseComplete();

        // switch to free spin ambiance sound
        SlotGame.sound.fadeAmbience(1, 0);
        SlotGame.sound.playAmbience(TombOfNefertitiSoundConfig.instance.BONUS_GAME_AMBIANCE);

        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.FS_INTRO_PAPER_CLOSE);

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    }
}